export const projects = [
  {
    title: "SKYTICKET (HOTEL)",
    duration: "Apr 2024 – Present",
    description:
      "Hotel reservation web app built with React.js for customers and a hotel manager dashboard built with Vue.js.",
    tech: ["React.js", "Next.js", "REST API", "Tailwind CSS"],
    image:
      "https://res.cloudinary.com/dpjxzalpe/image/upload/v1763581545/Screenshot_2025-11-19_132827_xu7sbv.png",
    liveUrl: "https://skyticket.jp/hotel/",
  },
  {
    title: "STUDENT UPLIFT",
    duration: "Mar 2023 – Mar 2024",
    description:
      "Cross-platform mobile and web app with chat, video calling, and program management features.",
    tech: ["React Native", "React", "Next.js", "WebRTC", "Firebase"],
    image:
      "https://res.cloudinary.com/dpjxzalpe/image/upload/v1763581678/studentuplift_zxdkfb.webp",
    liveUrl:
      "https://docs.google.com/document/d/1OUJhqr-93o8T4GrKBabnzIza99NCRaQlTlKqdv35-EQ/edit?tab=t.0",
  },
  {
    title: "DIGITAL PHARMACY",
    duration: "Jan 2024 – Mar 2024",
    description:
      "Modern pharmacy e-commerce platform with product search, cart, and authentication.",
    tech: ["Next.js", "Redux Toolkit", "Firebase"],
    image:
      "https://res.cloudinary.com/dpjxzalpe/image/upload/v1763582357/Screenshot_2025-11-19_134213_admt3v.png",
    liveUrl: "https://pablo.digitalpharmacy.io/en",
  },
  {
    title: "TELEDOC",
    duration: "Jun 2022 – Feb 2023",
    description:
      "Unified telemedicine platform for Android and web with video consultations and clinic management.",
    tech: ["React Native", "React", "Node.js", "Material UI", "Socket.IO"],
    image:
      "https://media.istockphoto.com/id/1238595682/vector/onlinedoctor.jpg?s=612x612&w=0&k=20&c=otZV2at5Sf7iNXEQUXXU19vZRliedgUj3OpMshqLfKM=",
    liveUrl: "https://youtu.be/POxSG5ZTYW4",
  },
];
